import React from "react";
import PropTypes from "prop-types";

const INACTIVE_COLOR = "#b2b8c7";
const ACTIVE_COLOR = "#0431b0";

const snapshot = value => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    return value;
  }
};

/**
 * A save button that becomes blue when its listing has unsaved changes.
 */
class ListingSaveButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.savedSnapshot = snapshot(props.listing);
    this.state = { isDirty: false };
  }

  componentDidUpdate(prevProps) {
    const currentSnapshot = snapshot(this.props.listing);
    const trackingJustStarted =
      !prevProps.trackingEnabled && this.props.trackingEnabled;
    const saveCompleted =
      this.props.saveResult && prevProps.saveResult !== this.props.saveResult;

    if (!this.props.trackingEnabled || trackingJustStarted || saveCompleted) {
      this.savedSnapshot = currentSnapshot;
    }

    const isDirty =
      this.props.trackingEnabled && currentSnapshot !== this.savedSnapshot;

    if (isDirty !== this.state.isDirty) {
      this.setState({ isDirty });
    }
  }

  handleClick = async event => {
    const result = await this.props.onClick(event);

    if (this.props.resetWhenClickResolves && result === true) {
      this.savedSnapshot = snapshot(this.props.listing);
      this.setState({ isDirty: false });
    }

    return result;
  };

  render() {
    const {
      style,
      disabled,
      type,
      name,
      className,
      children
    } = this.props;
    const isHighlighted = this.state.isDirty && !disabled;
    const color = isHighlighted ? ACTIVE_COLOR : INACTIVE_COLOR;

    return (
      <button
        type={type}
        name={name}
        className={className}
        disabled={disabled}
        onClick={this.handleClick}
        data-dirty={this.state.isDirty}
        style={{
          ...style,
          background: color,
          border: `1px solid ${color}`
        }}
      >
        {children}
      </button>
    );
  }
}

ListingSaveButton.propTypes = {
  listing: PropTypes.any,
  saveResult: PropTypes.any,
  trackingEnabled: PropTypes.bool,
  resetWhenClickResolves: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

ListingSaveButton.defaultProps = {
  trackingEnabled: true,
  resetWhenClickResolves: false,
  style: {},
  disabled: false
};

export default ListingSaveButton;
